class Queue {
    constructor () {
        this._items = [];
    }

    addImage (item) {
        this._items.push(item);
    }

    processQueue () {
        return this._items.shift();
    }

    get size () {
        return this._items.length;
    }
}

export class UploadQueue extends Queue {
    constructor () {
        super();
        this._pendingPromise = false;
    }

    addImage (action) {
        return new Promise((resolve, reject) => {
            super.addImage({ action, resolve, reject });
            this.processQueue();
        });
    }

    async processQueue () {
        if (this._pendingPromise) return false;

        const item = super.processQueue();

        if (!item) return false;

        try {
            this._pendingPromise = true;

            const payload = await item.action(this);

            this._pendingPromise = false;
            item.resolve(payload);
        } catch (error) {
            this._pendingPromise = false;
            item.reject(error);
        } finally {
            this.processQueue();
        }

        return true;
    }
}
